import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 50px 50px 50px;
  min-height: 0;
`;

export const PopupHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
`;

export const PopupTitle = styled(Typography.Header)`
  font-size: 22px;
  font-weight: 700;
  text-align: center;
`;

export const PopupCloseButton = styled(Button)`
  position: absolute;
  right: 0;
  height: 100%;
  cursor: pointer;
`;
